import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import {handleScrollToHash} from "../services/services";
import PhoneSwiper from "../components/Common/PhoneSwiper";
import TopUp from "../components/SHB/TopUp";


const dataTopUp = [
	{id: 0, title: 'Vào ứng dụng FUTA và tiến hành các bước mua vé'},
	{id: 1, title: 'Đến phần Phương thức thanh toán, chọn “GooPay”'},
	{
		id: 2, title: 'Sau khi chọn cổng thanh toán GooPay, màn hình sẽ chuyển sang ứng dụng ví GooPay\n' +
			'1. Đăng nhập ví GooPay \n' +
			'2. Kiểm tra Thông tin thanh toán \n' +
			'3. Bấm “Thanh toán”'
	},
	{
		id: 3, title: 'Xác nhận thông tin giao dịch và bấm “Tiếp tục”'
	},
	{id: 4, title: 'Nhập mã PIN'},
	{id: 5, title: 'Xác thực OTP'},
	{
		id: 6,
		title: 'Thanh toán thành công Hệ thống tự động chuyển hướng về ứng dụng FUTA. Quá trình mua vé hoàn tất thành công'
	},

];
const GuildFutaTicket = () => {
	const [activeTab, setActiveTab] = useState(0);
	const [step, setStep] = useState(0);
	const location = useLocation();
	const {hash} = location || {};
	
	useEffect(() => {
		handleScrollToHash({sectionId: hash.substring(1)});
	}, [hash]);
	
	const tabs = [
		{
			label: 'Nạp tiền vào Ví', quantity: 7, content: <TopUp
				renderNote={
					<div className='mt-5'>
						<strong>Hướng dẫn xem thông tin vé</strong>
						<p className='py-2'>Để kiểm tra vé đã đặt, vào mục Lịch sử > Danh sách vé > Chọn vé đã mua để xem chi tiết. Tại phần mã QR,
							bấm ”Tải về” để lưu lại mã vé</p>
						<p>Quý khách có thể trình mã QR đã lưu hoặc thông tin vé này cho nhân viên soát vé trước khi lên xe</p>
					</div>
				}
				isSHB data={dataTopUp} setStep={setStep} step={step}/>
		},
	];
	
	return (
		<div className="mx-auto w-full animate-fadeIn text-sm space-y-5 md:space-y-10 pt-10">
			<div className='flex justify-center items-center text-center space-x-4 text-sm md:text-[17px] font-bold'>
				<div>
					Hướng dẫn thanh toán bằng cổng GooPay khi mua vé trên ứng dụng FUTA
				</div>
			</div>
			
			<div className="mx-auto w-fit">
				<div
					className='flex flex-wrap md:font-normal justify-center items-center md:justify-start md: md:items-start font-bold md:space-x-14'>
					<div
						className="bg-transparent rounded-b-lg pb-4 md:pb-0 mx-auto"
						role="tabpanel"
						id={`tabpanel-${activeTab}`}
						aria-labelledby={`tab-${activeTab}`}
					>
						<PhoneSwiper
							path={'guild-step/futa-ticket'}
							activeTab={activeTab}
							step={step}
							setStep={setStep}
							setActiveTab={setActiveTab}
							quantity={tabs[activeTab]?.quantity}
						/>
					</div>
					{tabs[activeTab].content}
				</div>
			</div>
			<img className="z-[-1] mt-[-100px] md:mt-[-200px] w-full" src="/img/bg-city.png" alt="bg-city"/>
		</div>
	)
};

export default GuildFutaTicket;
